import { Swiper, SwiperSlide } from "swiper/react";
import "./css/AboutUs.css";
import { Row, Col, Container } from "react-bootstrap";

import { Link } from "react-router-dom";
import Logo_1 from "../assets/Logo_1.png";
import React, { useRef, useState } from "react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import "./css/Gallery.css";

import ParticleBackground from "./ParticleBackground";

import { EffectCoverflow, Pagination } from "swiper";
const AboutUs = () => {
  return (
    <div className="bg">
      <div className="title">
        <img className="logo" src={Logo_1} alt="" />
        <h1 style={{ fontSize: "1em", fontFamily: "Poppins" }}>
          THAPAR ADVENTURE CLUB
        </h1>
        {/* <Link to="/udaipur_trip" target="_blank">
          {" "}
          <div class="button_slide slide_right">
            Registerations for Udaipur-Jaipur-2023!
          </div>
        </Link> */}
      </div>

      <section className="content-section">
        <Container>
          <Row style={{ marginTop: "70px" }}>
            <Col style={{ marginTop: "-70px" }} lg={6} sm={12}>
              <img width="50%" src={Logo_1} alt="" />
            </Col>
            <Col lg={6} sm={12}>
              <h1 style={{ fontFamily: "Bebas Neue" }}>ABOUT US!</h1>
              <p style={{ fontFamily: "Poppins", marginTop: "5%" }}>
                Thapar Adventure Club is a platform for the travel enthusiasts
                and those who love Adventure. Our aim is to promote traveling
                and conduct adventure activities for the students of our
                Institute. It organizes trips for students to unwind, have fun
                and discover themselves. These trips also include a range of
                adventure activities such as trekking, climbing, hiking, rafting
                and skiing. It fuels the adrenaline rush that travel incites and
                gives an opportunity to meet fellow travellers, make new friends
                and explore the offbeat destinations
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section id="gallerySection">
        <h1 style={{ fontFamily: "Bebas Neue" }}> Gallery</h1>
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination]}
          className="mySwiper"
        >
          <SwiperSlide>
            <img src={"images/IMG_0101.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_0109.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_0133.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_0139.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_0233.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_0327.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_0432.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_1767.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_3441.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_3787.jpg"} />
          </SwiperSlide>
          <SwiperSlide>
            <img src={"images/IMG_4085.jpg"} />
          </SwiperSlide>
        </Swiper>
      </section>
    </div>
  );
};

export default AboutUs;
